export default "__VITE_ASSET__CQttQXhZ__"